<template>
  <div class="page">
    <template v-if="!applied">
      <div class="page-container v-pt-lg">
        <div class="page-title">项目总结报告</div>
        <div class="page-steps w600">
          <a-steps progress-dot class="v-mt-lg v-mb-md" size="small" :current="currentStep">
            <a-step title="提交项目报告">
              <div slot="description" style="white-space: nowrap; font-size: 12px" v-if="report.state > 0">
                <div>{{ report.submitTime ? report.submitTime.substring(0, 16) : '' }}</div>
              </div>
            </a-step>
            <a-step title="项目主管审核" />
            <a-step title="完成" />
          </a-steps>
        </div>
        <div class="panel-body">
          <div class="w800">
            <a-form-model class="form-sm" ref="form">
              <a-form-model-item :colon="false" v-if="report.checkResult === -1">
                <span slot="label"></span>
                <a-alert class="v-mb-sm no-border" type="error">
                  <div slot="message">
                    <div class="font-md text-darkblue flex items-center">
                      <a-icon type="alert" class="v-mr-xs" />
                      提交的项目报告已被驳回
                    </div>
                    <div class="flex v-mt-xs">
                      <span class="text-right text-grey">审核意见：</span>
                      <span class="col text-red" v-html="$utils.convertToHtml(report.checkOpinion)"></span>
                    </div>
                  </div>
                </a-alert>
              </a-form-model-item>
              <a-row>
                <a-col span="12">
                  <a-form-model-item :colon="false">
                    <span slot="label">
                      <i class="required-mark">*</i>
                      项目类型
                    </span>
                    <a-space>
                      <a-select placeholder="项目类型" v-model="form.ptype" style="width: 300px" ref="ptype">
                        <a-select-option :value="21">螺蛳壳改造</a-select-option>
                        <a-select-option :value="22">精灵书屋</a-select-option>
                        <a-select-option :value="23">公益人才</a-select-option>
                        <a-select-option :value="24">爱心100</a-select-option>
                        <a-select-option :value="25">其他项目</a-select-option>
                      </a-select>
                    </a-space>
                  </a-form-model-item>
                </a-col>
                <a-col span="12">
                  <a-form-model-item :colon="false">
                    <span slot="label">
                      <i class="required-mark">*</i>
                      报告类型
                    </span>
                    <a-space>
                      <a-select placeholder="选择报告类型" v-model="form.type" style="width: 240px" ref="type" @change="handleTypeChange">
                        <!-- <a-select-option :value="1">月报</a-select-option> -->
                        <a-select-option :value="5">年报（审计）</a-select-option>
                        <a-select-option :value="6">项目总结报告</a-select-option>
                      </a-select>
                      <a-date-picker :disabled-date="disabledDate" mode="year" placeholder="选择年份" v-model="form.year" :open="showYearPanel" ref="yearPicker" @openChange="onYearPanelOpen" format="YYYY年" value-format="YYYY" @panelChange="onYearChange" style="width: 100px" v-if="form.type == 5" />
                      <!-- <a-select placeholder="选择季度" v-model="form.quarter" style="width: 110px" ref="quarterPicker" @change="handleTypeChange" v-if="form.type == 2">
                      <a-select-option :value="1">第一季度</a-select-option>
                      <a-select-option :value="2">第二季度</a-select-option>
                      <a-select-option :value="3">第三季度</a-select-option>
                      <a-select-option :value="4">第四季度</a-select-option>
                    </a-select>
                    <a-select placeholder="选择月份" v-model="form.month" style="width: 110px" ref="monthPicker" @change="handleTypeChange" v-else-if="form.type == 1">
                      <a-select-option :value="1">1月</a-select-option>
                      <a-select-option :value="2">2月</a-select-option>
                      <a-select-option :value="3">3月</a-select-option>
                      <a-select-option :value="4">4月</a-select-option>
                      <a-select-option :value="5">5月</a-select-option>
                      <a-select-option :value="6">6月</a-select-option>
                      <a-select-option :value="7">7月</a-select-option>
                      <a-select-option :value="8">8月</a-select-option>
                      <a-select-option :value="9">9月</a-select-option>
                      <a-select-option :value="10">10月</a-select-option>
                      <a-select-option :value="11">11月</a-select-option>
                      <a-select-option :value="12">12月</a-select-option>
                    </a-select> -->
                    </a-space>
                  </a-form-model-item>
                </a-col>
              </a-row>
              <a-form-model-item :colon="false">
                <span slot="label">
                  <i class="required-mark">*</i>
                  报告内容
                </span>
                <report-editor id="myedit" ref="editor" :report-id="reportId" :project-type.sync="form.ptype" v-model="form.content" :min-height="800" :file-params="{ fileBelongId: reportId, fileType: 12, fileSign: 'REPORT' }" />
              </a-form-model-item>
            </a-form-model>
            <div class="text-center v-mt-lg">
              <a-space>
                <a-button icon="check" type="indigo" key="draft" @click="handleConfirmSubmit(false)" :loading="saving">保存初稿</a-button>
                <a-button icon="arrow-right" type="primary" key="submit" @click="handleConfirmSubmit(true)" :loading="saving">提交</a-button>
                <a-button icon="left" type="default" key="backward" @click="$router.go(-1)">返回</a-button>
              </a-space>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <a-result status="success" title="提交成功" sub-title="您填报的项目总结报告已提交审核，请耐心等待审核结果。">
        <template #extra>
          <a-button key="view" type="primary" @click="$router.push(`./detail?rid=${reportId}`)">查看报告</a-button>
          <a-button key="back" @click="$router.go(-1)">返回</a-button>
        </template>
      </a-result>
    </template>
  </div>
</template>

<script>
import ReportEditor from './editor'
import { OWN_REPORT_CONTENT } from '@/utils/report'
import { getReport, saveSummaryReport } from '@/api/project/common'
export default {
  name: 'ProjectSummaryReportDetail',
  components: {
    ReportEditor,
  },
  data() {
    return {
      applied: false,
      id: undefined,
      projectId: undefined,
      reportId: undefined,
      currentStep: 0,
      saving: false,
      project: {},
      report: {},
      medias: [],
      form: {
        projectType: undefined,
        type: 5,
        year: undefined,
        month: undefined,
        quarter: undefined,
        content: OWN_REPORT_CONTENT,
        fileIds: [],
      },
      fileList: [],
      uploadMediaType: 1,
      uploadFiles: [],
      showUploadModal: false,
      isChoice: false,
      showYearPanel: false,
    }
  },
  methods: {
    init() {
      let { id, rid } = this.$route.query
      if (rid) {
        // 草稿，从详情中取
        this.reportId = +rid
        this.loadRecord()
      }
    },
    loadRecord() {
      this.loading = true
      getReport(this.reportId).then(({ data }) => {
        if (data.success) {
          this.report = data.result
          let { content, ptype, type, year, month, quarter } = data.result
          this.form = {
            ptype,
            type,
            year: year ? `${year}` : undefined,
            month,
            quarter,
            content,
          }
        }
      })
    },
    disabledDate(current) {
      return current && current > this.$moment().endOf('day')
    },
    onYearChange(date) {
      this.form.year = date.format('YYYY')
      this.handleTypeChange()
      this.showYearPanel = false
    },
    onYearPanelOpen(status) {
      this.showYearPanel = status
    },
    handleConfirmSubmit(nextStep) {
      this.$message.destroy()
      let { ptype, type, year, quarter, month } = this.form
      if (!ptype) {
        this.$refs.ptype.focus()
        this.$message.warn('请选择项目类型')
        return
      }
      if (!type) {
        this.$refs.type.focus()
        this.$message.warn('请选择报告类型')
        return
      }
      if (type == 5 && !year) {
        this.$refs.yearPicker.focus()
        this.$message.warn('请选择报告年份')
        return
      }
      if (type == 1 && !month) {
        this.$refs.monthPicker.focus()
        this.$message.warn('请选择报告月份')
        return
      }
      if (type == 2 && !quarter) {
        this.$refs.quarterPicker.focus()
        this.$message.warn('请选择报告季度')
        return
      }
      this.$confirm({
        title: nextStep ? '确认提交项目总结报告？' : '确认保存初稿？',
        centered: true,
        onOk: () => {
          this.handleSubmit(nextStep)
        },
      })
    },
    handleSubmit(nextStep) {
      let { projectId, reportId } = this
      let { ptype, type, content, year, month, quarter } = this.form
      let params = {
        ptype,
        origin: 1,
        reportId,
        projectId,
        type,
        year,
        month,
        quarter,
        content: content.trim(),
        nextStep,
      }
      this.saving = true
      saveSummaryReport(params)
        .then(({ data }) => {
          if (data.success) {
            this.reportId = data.result
            if (nextStep) {
              this.applied = true
            } else {
              this.$message.success('操作成功')
              this.$router.push(`./list`)
            }
          } else {
            this.$message.warning(data.msg)
          }
          this.saving = false
        })
        .catch(err => {
          if (err) {
            this.$message.warning(err)
          }
          this.saving = false
        })
    },
    handleUploadChange(info, count) {
      this.uploadFiles = this.handleUploadFile(info, count)
      this.$refs.uploadFiles.$el.classList.remove('uploader-empty')
    },
    handleRemoveFile(index) {
      this.medias.splice(index, 1)
    },
    openUploadModal() {
      this.uploadFiles = []
      this.showUploadModal = true
    },
    cancelUploadModal() {
      this.showUploadModal = false
    },
    handlUploadSubmit() {
      this.$message.destroy()
      let { uploadFiles, isChoice } = this
      if (uploadFiles.length === 0) {
        this.$message.warn('请选择上传文件')
        this.$refs.uploadFiles.$el.classList.add('uploader-empty')
        return
      }
      let files = this.$utils.cloneDeep(uploadFiles)
      let file = files[0] || {}
      this.medias.push({
        uid: Math.random(),
        isChoice,
        fileId: file.fileId,
        file,
        files,
      })
      this.cancelUploadModal()
    },
    handleTypeChange() {
      // this.$refs.editor.refresh(this.form)
    },
  },
  created() {
    this.init()
  },
}
</script>
